import ctaContent from '@content/finalcta.yaml'
import type { FinalCtaContent } from '@/types/content'

const content = ctaContent as unknown as FinalCtaContent

export function FinalCta() {
  return (
    <div className="final-cta">
      <div>
        <h2 className="fc-h2" dangerouslySetInnerHTML={{ __html: content.headline }} />
        <p className="fc-sub">{content.subtext}</p>
      </div>
      <div className="fc-actions">
        {content.actions.map(action => (
          <a key={action.href} href={action.href} className={action.style === 'primary' ? 'btn-cm' : 'btn-cg'}>{action.label}</a>
        ))}
      </div>
    </div>
  )
}
